import type { SurveyCreator } from "survey-creator-react";

export const applySurveyPropertyVisibility = (creator: SurveyCreator) => {
    const hiddenProperties = [
        // ❗ Creator-only layout controls
        "questionBoxCollapseState",

        // Question layout
        "startWithNewLine",
        "collapseState",
        "indent",
        "width",
        "minWidth",
        "maxWidth",
        "state",

        // Alignment
        "titleLocation",
        "descriptionLocation",
        "errorLocation",
        "inputTextAlignment",

        // Input sizing
        "inputSize",

        // 🚫 Survey → Navigation / behavior
        "surveyLayout",
        "isFirstPage",
        "goNextPageAutomatic",
        "showNavigationButtons",
        "navigationButtonsLocation",
        "showPrevButton",
        "showProgressBar",
        "showTOC",
        "showPreviewBeforeComplete",
        "pagePrevText",
        "pageNextText",
        "completeText",
        "questionsOnPageMode",
        "firstPageIsStartPage",
        "autoAdvanceEnabled",
        "autoAdvanceAllowComplete",

        // Mask Properites
        "maskType",
        "maskSettings",
        "saveMaskedValue",

        // Data Properties
        "valueName",
        "defaultValue",
        "correctAnswer",
        "useDisplayValuesInDynamicTexts",
        "defaultDisplayValue",
        "textUpdateMode",
        "clearIfInvisible",
        "maxErrorText",
        "clearInvisibleValues",
        "autoSaveOnPageChange",
        "storeOthersAsComment",

        // Logo Properties
        "logo",
        "logoWidth",
        "logoHeight",
        "logoFit",

        // Question Settings
        "questionOrder",
        "questionTitleLocation",
        "questionDescriptionLocation",
        "showQuestionNumbers",
        "questionTitlePattern",
        "requiredMark",
        "questionStartIndex",
        "questionErrorLocation",
        "autoFocusFirstQuestion",
        "maxTextLength",
        "maxCommentLength",
        "commentAreaRows",
        "autoGrowComment",
        "allowResizeComment",

        // Pages Properties
        "showPageTitles",
        "showPageNumbers",
        "gridLayoutEnabled",


        "triggers",

        "autoFocusFirstQuestion",
        "effectiveColSpan",

        "completedHtml",
        "completedHtmlOnCondition",
        "showCompletedPage",
        "navigateToUrl",
        "expression",
        "html",
        "loadingHtml",
        "navigateToUrlOnCondition",
        "showCompletePage",


        "step",
        "visibleIf",
        "enableIf",
        "requiredIf",
        "bindings",
        "defaultValueExpression",
        "resetValueIf",
        "setValueIf",
        "setValueExpression",

        "showTimer",
        "timerLocation",
        "timeLimit",
        "timeLimitPerPage",
        "timerInfoMode",
        "eachRowRequired",
        "eachRowUnique",
        "rowsVisibleIf",
        "columnsVisibleIf",
        "effectiveColSpan",
        "columnMinWidth",
        "rowTitleWidth",
        "showHeader",
        "verticalAlign",
        "alternateRows",
        "cells",

        "maxValueExpression",
        "minValueExpression",
        "defaultValueExpression",
        "setValueExpression",
        "minErrorText",

        "allowResize",
        "allowResizeComment",
        "autoGrow",
        "choices",
        "maxLength",
        "colCount",
        "itemTitleWidth",
        "items",
        "min",
        "max",
        "choicesFromQuestion",
        "choicesFromQuestionMode",
        "choiceValuesFromQuestion",
        "choiceTextsFromQuestion",
        "choicesOrder",
        "allowCustomChoices",
        "choicesMin",
        "choicesMax",
        "choicesStep",
        "choicesByUrl",
        "hideIfChoicesEmpty",
        "choicesVisibleIf",
        "choicesEnableIf",
        "showOtherItem",
        "textWrapEnabled",
        "showOtherItem",
        "otherText",
        "otherPlaceholder",
        "showNoneItem",
        "searchMode",
        "allowClear",


        "showSelectAllItem",
        "selectAllText",
        "minSelectedChoices",
        "maxSelectedChoices",
        "separateSpecialChoices",
        "valuePropertyName",

        "hideSelectedItems",
        "searchMode",
        "searchEnabled",


        "hideIfRowsEmpty",
        "rowOrder",
        "transposeData",
        // "choices",
        "cellErrorLocation",
        "columnColCount",
        "keyDuplicationError",

        "innerIndent",
        "showNumber",
        "requiredErrorText",
        "templateQuestionTitleLocation",
        "errorLocation",
        "removePanelButtonLocation",
        "nextPanelText",
        "visibleIf",

        "inputType",
        "description",
        "readOnly",
        "visible",
        "visibleIf",
        "enableIf",
        "requiredIf",
        "widthMode",
        "showTitle",
        "locale",
        "autoFocusFirstError",
        "title",
        "validators"
    ];

    creator.onCanShowProperty.add((_, options) => {
        const prop = options.property;
        if (!prop) return;

        if (hiddenProperties.includes(prop.name)) {
            options.canShow = false; // ✅ THIS is the key
        }
    });
};
